module.exports = __webpack_public_path__ + "img/258.b0d08cde.jpg";